import { render } from "./DashboardInquiry.vue?vue&type=template&id=a87bdaba&scoped=true"
import script from "./DashboardInquiry.vue?vue&type=script&lang=js"
export * from "./DashboardInquiry.vue?vue&type=script&lang=js"

import "./DashboardInquiry.vue?vue&type=style&index=0&id=a87bdaba&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87bdaba"]])

export default __exports__